import * as React from "react";
import { useAuth } from "../../../App";
import { OrthodonticReferralDecisionApi } from "../../../api/OrthodonticReferralDecisionApi";
import { SpinnerWrapper } from "soprasteria-ui-library";
import { IOrthodonticReferralAdvancedConsultationNeed } from "../../../models/IOrthodonticReferral";
import { OrthodonticReferralAdvancedConsultationNeedsForJointConsultationGroupTable } from "./OrthodonticReferralAdvancedConsultationNeedsForJointConsultationGroupTable";

export const OrthodonticReferralAdvancedConsultationNeedsForJointConsultationGroup: React.FunctionComponent<{}> = () => {

    const auth = useAuth();
    const api = new OrthodonticReferralDecisionApi(auth);
    const [orthodonticReferralAdvancedConsultationNeeds, setOrthodonticReferralAdvancedConsultationNeeds] = React.useState<IOrthodonticReferralAdvancedConsultationNeed[]>();

    React.useEffect(() => {
        getOrthodonticReferralAdvancedConsultationNeeds();
    }, [])

    const getOrthodonticReferralAdvancedConsultationNeeds = () => {
        api.getOrthodonticReferralAdvancedConsultationNeedsForJointConsultationGroup((data) => {
            setOrthodonticReferralAdvancedConsultationNeeds(data);
        })
    }

    return (
        <section className="card">
            <SpinnerWrapper isLoading={orthodonticReferralAdvancedConsultationNeeds === undefined}>
                <div className="card-header">
                    <h1>Ortodontiremisser som skickats till samrådsgruppen</h1>
                </div>
                <div className="card-body">
                    {
                        orthodonticReferralAdvancedConsultationNeeds ?
                            <OrthodonticReferralAdvancedConsultationNeedsForJointConsultationGroupTable orthodonticReferralAdvancedConsultationNeeds={orthodonticReferralAdvancedConsultationNeeds} />
                            : null
                    }
                </div>
            </SpinnerWrapper>
        </section>
    )
}